// Mock data for Momentedge website

export const companyInfo = {
  name: "Momentedge",
  tagline: "Data intelligence infrastructure for deployed autonomy",
  description: "Robotics teams generate massive amounts of multimodal data, but capturing the right data and turning it into actionable insight still takes significant engineering work. Momentedge helps teams collect high-value data, surface important events, and assemble the context needed to investigate issues and identify root causes. From fleet operations to evaluation and training, we turn real-world robot data into information teams can act on.",
};

export const features = [
  {
    id: 1,
    title: "Process multimodal robot data",
    description: "Bring together telemetry, logs, ROS data, video, sensor streams, and operational events.",
    icon: "layers"
  },
  {
    id: 2,
    title: "Surface what deserves attention",
    description: "Identify failures, anomalies, unusual behavior, and other events worth investigating — including events teams may not have explicitly instrumented.",
    icon: "scan-search"
  },
  {
    id: 3,
    title: "Assemble the relevant context",
    description: "Pull together the data surrounding an event so engineers can understand what happened without manually searching through hours of recordings.",
    icon: "puzzle"
  },
  {
    id: 4,
    title: "Feed what you learn back into collection",
    description: "Use what matters in deployment to improve what gets captured, retained, and analyzed next.",
    icon: "refresh-cw"
  }
];

export const aboutUs = {
  mission: "At Momentedge, we're solving one of the most critical challenges in autonomous systems: capturing the right data at the right time. Our mission is to make robotics training data collection efficient, cost-effective, and intelligent.",
  vision: "We envision a future where autonomous systems learn continuously from real-world experiences without the burden of managing petabytes of redundant data.",
  story: "Founded by engineers who've built and deployed autonomous systems at scale, we understand the pain of data collection firsthand. After years of wrestling with bandwidth constraints, storage costs, and missing critical edge cases, we built Momentedge - the platform we wished we had.",
  team: "Our team brings together expertise in robotics, distributed systems, machine learning, and edge computing from leading autonomous vehicle and robotics companies."
};

export const knowMore = {
  problem: {
    title: "The Data Collection Dilemma",
    points: [
      "Autonomous fleets generate 1-10TB of sensor data per vehicle per day",
      "99% of this data is repetitive highway driving or nominal operations",
      "The critical 1% - near-misses, unusual scenarios, edge cases - is buried in the noise",
      "Traditional solutions: record everything (expensive) or nothing (risky)"
    ]
  },
  solution: {
    title: "How Momentedge Works",
    steps: [
      {
        step: 1,
        title: "Edge Intelligence",
        description: "Our lightweight agent runs on your robots, analyzing sensor streams in real-time to detect anomalies and interesting scenarios."
      },
      {
        step: 2,
        title: "Smart Triggering",
        description: "Configurable rules and ML models automatically trigger high-fidelity recording when something worth capturing happens."
      },
      {
        step: 3,
        title: "Optimized Upload",
        description: "Only relevant data segments are uploaded to your data lake, with compression and prioritization built-in."
      },
      {
        step: 4,
        title: "Model Integration",
        description: "Seamlessly feed collected data into your training pipelines with full metadata and sensor calibration preserved."
      }
    ]
  },
  benefits: {
    title: "Impact",
    metrics: [
      { label: "Storage Cost Reduction", value: "99%" },
      { label: "Bandwidth Savings", value: "95%" },
      { label: "Edge Case Coverage", value: "10x" },
      { label: "Time to Model Improvement", value: "5x faster" }
    ]
  }
};

export const navigation = [
  { name: "Home", path: "/" },
  { name: "Docs", path: "/docs" },
  { name: "About Us", path: "/about" },
  { name: "Resources", path: "/resources" }
];

export const contactInfo = {
  email: "hello@momentedge.xyz",
  social: {
    linkedin: "https://www.linkedin.com/in/melikagolkaram/",
    github: "#",
    twitter: "#"
  }
};
